import { render } from "./AlbumDetails.vue?vue&type=template&id=18b6d073"
import script from "./AlbumDetails.vue?vue&type=script&lang=js"
export * from "./AlbumDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__